import "./GreenButton.scss";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
// { text, size, variant, type, icon, onClick, loading }
const GreenButton = (props) => {
  const getSizeStyle = () => {
    switch (props?.size) {
      case "small":
        return { width: "100px" };
      case "medium":
        return { width: "150px" };
      case "large":
        return { width: "200px" };
      case "full":
        return { width: "100%" };
      case "fit":
        return { width: "fit-content" };
      default:
        return {};
    }
  };
  const sizeStyle = getSizeStyle();
  const navigate = useNavigate();
  const handleClick = () => {
    if (props?.loading) return; // Prevent click when loading
    if (props?.path) {
      navigate(props.path);
    }
    if (props?.onClick) {
      props.onClick();
    }
  };

  const getButtonClass = () => {
    if (props?.variant === "fill") {
      return "fill outlined";
    } else if (props?.variant === "cancel") {
      return "outlined cancel";
    } else {
      return "outlined";
    }
  };

  return (
    <button
      type={props?.type}
      className={getButtonClass()}
      style={sizeStyle}
      onClick={handleClick}
      disabled={props?.loading || props?.disabled}
    >
      {props?.loading ? (
        <CircularProgress size={24} color="inherit" />
      ) : (
        <>
          {props?.icon && props?.icon}
          {props?.text}
        </>
      )}
    </button>
  );
};
export default GreenButton;
